import "core-js/modules/es.object.assign.js";
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import { TOGGLE_MODAL } from '@/constants/detail';
import VMask from './VMask';
export default {
  name: 'widget__modal',
  components: {
    'v-mask': VMask
  },
  props: {
    close: {
      type: Boolean,
      default: true
    },
    mask: {
      type: Boolean,
      default: true
    }
  },
  methods: Object.assign({}, mapActions([TOGGLE_MODAL]))
};